<template>
  <div class="content">
    <h1>Thanks!</h1>
    <h2 v-if="reference" class="px-4">Your order reference is:<br/>#{{reference}}</h2>
    <div class="text-center px-4" v-html="compiledMarkdown" />

    <p class="my-4 p-4 border">Please remember to collect your order between<br><strong v-if="christmasEve">10.30am - 1pm</strong><strong v-else-if="thursday">1pm - 2pm</strong><strong v-else>10.30am - 2.30pm</strong> on <strong>{{pickupDate}}</strong></p>

    <div class="mt-16 mx-4">
      <h2>Before you go...</h2>
      <p>Would you like to join our mailing list?</p>
      
      <MailingList />
    </div>

  </div>
</template>


<script>
import marked from 'marked';
import { forEach } from 'lodash'
import MailingList from '../components/MailingList'
import lscache from 'lscache';
import dayjs from 'dayjs'

export default {
  computed: {
    compiledMarkdown: function () {
      return marked(this.$root.$data.images.thanks)
    },
    reference() {
      return this.$router.currentRoute.params.reference
    },
    pickupDate() {
      return dayjs(this.$router.currentRoute.params.date).format('dddd, DD MMMM YYYY')
    },
    christmasEve() {
      return dayjs(this.order.date).isSame(dayjs('2021-12-24'),'date')
    },
    thursday() {
      return false
      // if(
      //   dayjs(this.$router.currentRoute.params.date).isSame(dayjs('2021-03-11'),'d')
      // ) { 
      //   return false
      // } else {
      //   return dayjs(this.$router.currentRoute.params.date).toDate().getDay() == 4
      // }
    }
  },  
  components: {
    MailingList
  },
  head: {
    title() {
      return {
        inner: "Thanks"
      }
    },
  },
  mounted() {


    try {
      if(lscache.get('basket')) {
      const basket = lscache.get('basket')
      const products = this.$root.$data.products
      let items = []
      let total =

      forEach(basket, (item) => {
        const product = products.find(p => p.sku == item.sku)

        total += product.amount

        let litem = {
          id: product.sku,
          name: product.name,
          price: product.amount,
          quantity: 1,
        };

        items.push(litem)
      })
      
      window.gtag('event', 'purchase', {
        "transaction_id": this.$router.currentRoute.params.reference,
        "value": total,
        "currency": "GBP",
        "shipping": 0,
        "items": items
      });
      }
    } catch(e) {
      console.log(e)
    }

    lscache.remove('basket')
    localStorage.order = null
  }

}
</script>

<style>

</style>